<template lang='pug'>
v-card(flat)
  v-card-title
    v-layout(align-center)
      div(class='title') Менеджер
      v-spacer
      v-btn(v-if='manager' @click='$emit("unlink")' icon)
        v-icon link_off
      v-btn(v-else @click='$emit("link")' icon)
        v-icon link
  v-divider
  v-list(v-if='manager' dense)
    v-list-tile
      v-list-tile-content(class='grey--text') Фамилия:
      v-list-tile-content(class='align-end') {{ manager.second_name }}
    v-list-tile
      v-list-tile-content(class='grey--text') Имя:
      v-list-tile-content(class='align-end') {{ manager.first_name }}
    v-list-tile
      v-list-tile-content(class='grey--text') Отчество:
      v-list-tile-content(class='align-end') {{ manager.patronymic_name }}
    v-list-tile
      v-list-tile-content(class='grey--text') Должность:
      v-list-tile-content(class='align-end') {{ manager.position }}
    v-list-tile
      v-list-tile-content(class='grey--text') Дата рождения:
      v-list-tile-content(class='align-end') {{ manager.birthday | date }}
  v-list(v-else dense)
    v-list-tile
      v-list-tile-content(class='grey--text') Менеджер не назначен
</template>

<script>
export default {
  props: {
    manager: {
      type: Object
    }
  }
}
</script>
